import type { RouteName } from '@jira/platform__routing-route-name-types/src/RouteName.tsx';
import type { JiraSpaRoute, RouterContext } from '@atlassian/react-resource-router';
import { MENU_ID_ITAM } from '../../../../constants.tsx';
import type { SelectedPath } from '../../../../types.tsx';

const routes = new Set<RouteName>(['itam', 'itam-ai-insights-preview', 'itam-settings']);

function convert(routeContext: RouterContext<JiraSpaRoute>): SelectedPath {
	const routeName: RouteName = routeContext.route.name;
	const path: string[] = [];
	return convertRouteToPath({ routeName, path });
}

function convertNew(args: { routeName: RouteName }): SelectedPath {
	const { routeName } = args;
	const path: string[] = [];
	return convertRouteToPath({ routeName, path });
}

function convertRouteToPath(args: { routeName: RouteName; path: string[] }): SelectedPath {
	const { routeName, path } = args;

	switch (routeName) {
		case 'itam':
		case 'itam-ai-insights-preview':
		case 'itam-settings':
			path.push(MENU_ID_ITAM);
			break;
		default:
	}

	return path;
}

export const itamConverter: {
	routes: Set<RouteName>;
	convert: typeof convert;
	convertNew: typeof convertNew;
} = { routes, convert, convertNew };
